<template>
    <div>
        <div class="header box-sizing">
            <el-button type="success" size="mini" @click="allRead">全部已读</el-button>
            <el-button type="primary" size="mini" @click="$router.back()">返回</el-button>
        </div>
        <div class="msg-list-box">
            <div class="notice_item" :class="{'select':item.sel,'news':!item.read}" v-for="item in list" @click="readMsg(item)">
                <div class="m-title">
                    <span>{{item.pm_title}}</span>
                    <div class="right-box">
                        <span>{{item.post_date}} </span>
                        <i :class="{'el-icon-arrow-up':item.sel,'el-icon-arrow-down':!item.sel}"></i>
                    </div>
                </div>
                <div class="m-content" v-html="item.pm_body"></div>
            </div>
            <div class="no-msg" v-if="list.length===0">暂时没有消息~</div>
        </div>
        <div class="pagebar" v-show="total>0">
            <el-pagination background layout="total, prev, pager, next, jumper" :total="total" @current-change="handleCurrentPage"></el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Message",
        data() {
            return {
                id: 0,
                list: [],
                total: 0,
                currentPage: 1,
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            setTimeout(this.getMsgList,200);
        },
        methods: {
            async getMsgList() {
                const getData = {
                    id:this.id,
                    p:this.currentPage,
                };
                const {ret,data} = await this.$api.notice.getList(getData);
                if (ret === 1000){
                    for (let item of data.list){
                        item.sel = item.pm_id === this.id;
                    }
                    this.total = data.total;
                    this.list = data.list;
                }
            },
            async pmRead(id) {
                console.log('pm read');
                const {ret} = await this.$api.notice.pmRead({id:id});
                if (ret === 1000){
                   console.log('操作成功');
                }
            },
            async allRead() {
                const {ret} = await this.$api.notice.readAll();
                if (ret === 1000){
                    this.getMsgList();
                    this.$message.success('操作成功');
                }
            },
            readMsg(item) {
                if (!item.sel){
                    for (let i of this.list) {
                        i.sel = false;
                    }
                }
                item.sel = !item.sel;
                if (!item.read) {
                    item.read = 1;
                    this.pmRead(item.pm_id);
                }
            },
            handleCurrentPage(val) {
                this.currentPage = val;
                this.getMsgList();
            }
        },
    }
</script>

<style scoped>
    .header{
        width: 100%;
        height: 80px;
        padding: 20px;
        text-align: right;
        border-bottom: 1px solid #e6e6e6;
    }
    .pagebar{
        width: calc(100% - 40px);
        height: 32px;
        padding: 20px;
        margin-top: 20px;
    }
    /*消息通知*/
    .msg-list-box{width: 100%;height: auto;}
    .msg-list-box .notice_item{width: calc(100% - 40px);padding: 20px;text-align: left;color: #9a9a9a;cursor: pointer;position: relative;}
    .msg-list-box .notice_item:before {content: " ";position: absolute;bottom: 0;left: 0;right: 0;border-bottom: 1px solid #e7e7eb;}
    .msg-list-box .notice_item.select{box-shadow: 0 0 20px #e4e8eb;-moz-box-shadow: 0 0 20px #e4e8eb;-webkit-box-shadow: 0 0 20px #e4e8eb;}
    .msg-list-box .notice_item .m-title{width: calc(100% - 180px);padding-right: 180px;position: relative;}
    .msg-list-box .notice_item .m-title .right-box{width: 180px;height: 20px;text-align: right;position: absolute;top: 0;right: 0;}
    .msg-list-box .notice_item .m-title .types{color: #808080;}
    .msg-list-box .notice_item.select .m-title span{color: #333333;}
    .msg-list-box .notice_item.news .m-title span{color: #333333;}
    .msg-list-box .notice_item .m-content{width: 100%;padding-top: 10px;color: #9a9a9a;display: none;}
    .msg-list-box .notice_item.select .m-content{display: block;}
    .msg-list-box .notice_item.select .iconxiala:before {content: "\e797";}
    .msg-list-box .no-msg{width: 100%;height: 80px;color:#666666;text-align:center;line-height: 80px;}
</style>
